export interface HintBadgeModePreference {
	enabled: boolean;
}

const storageKey = "keyboard.hintBadges";

export const hintBadgeModeChangeEvent = "worksuite:hint-badge-mode-change";

export const defaultHintBadgeMode: HintBadgeModePreference = { enabled: false };

const isHintBadgeMode = (value: unknown): value is HintBadgeModePreference =>
	typeof value === "object" && value !== null && typeof (value as HintBadgeModePreference).enabled === "boolean";

export const readHintBadgeMode = (): HintBadgeModePreference => {
	try {
		const raw = localStorage.getItem(storageKey);
		if (!raw) return defaultHintBadgeMode;
		const parsed = JSON.parse(raw) as unknown;
		if (!isHintBadgeMode(parsed)) return defaultHintBadgeMode;
		return { enabled: parsed.enabled };
	} catch {
		return defaultHintBadgeMode;
	}
};

export const writeHintBadgeMode = (preference: HintBadgeModePreference): void => {
	try {
		localStorage.setItem(storageKey, JSON.stringify(preference));
	} catch {
		// QuotaExceededError — storage full, keep the in-memory preference
	}
};
